import { Tooltip } from 'ui-components/components/tooltip';

import type { ReactNode } from 'react';

type DisabledControlTooltipProps = {
  label: string;
  children: ReactNode;
};

export const DisabledControlTooltip = ({ label, children }: DisabledControlTooltipProps) => (
  <Tooltip text={label}>
    {/* oxlint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- the span exists to give the disabled control's explanation a tab stop */}
    <span tabIndex={0}>{children}</span>
  </Tooltip>
);
